import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import './LegalPages.css';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const Terms = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  
  // Get current language from localStorage or default to 'de'
  const currentLang = localStorage.getItem('selected_language') || 'de';

  useEffect(() => {
    fetchTerms();
  }, [currentLang]);

  const fetchTerms = async () => {
    try {
      const response = await axios.get(`${API}/legal/terms?language=${currentLang}`);
      setContent(response.data.content);
    } catch (error) {
      console.error('Error loading terms:', error);
      setContent('Nutzungsbedingungen werden geladen...');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="legal-page-container">
        <div className="legal-loading">Lädt...</div>
      </div>
    );
  }

  return (
    <div className="legal-page-container">
      <div className="legal-content">
        <Button 
          variant="ghost" 
          className="back-button"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft size={20} /> Zurück
        </Button>

        <h1 className="legal-title">Nutzungsbedingungen</h1>
        
        <div 
          className="legal-text"
          dangerouslySetInnerHTML={{ __html: content }}
        />
        
        <div className="legal-footer">
          <p>Zuletzt aktualisiert: {new Date().toLocaleDateString('de-DE')}</p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
